import React from 'react';
import { Button } from '../ui';

export default function Topbar({ title, subtitle, actions }) {
  const today = new Date().toLocaleDateString('it-IT', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <header style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '20px 28px 16px',
      borderBottom: '1px solid var(--border)',
      position: 'sticky',
      top: 0,
      background: 'var(--navy)',
      zIndex: 10,
    }}>
      <div>
        <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: '22px', fontWeight: 500 }}>
          {title}
        </h1>
        <p style={{ fontSize: '12.5px', color: 'var(--text-muted)', marginTop: '2px' }}>
          {subtitle || today}
        </p>
      </div>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {actions}
        </div>
      )}
    </header>
  );
}
